import type { TestResultFormFieldsData } from '../forms/testResultSchema';

export const buildInsertControlTestResultArgs = (
  data: TestResultFormFieldsData
) => {
  const { files: _files, ParentControlIds, ...rest } = data;

  return {
    ...rest,
    CustomAttributeData: rest.CustomAttributeData || undefined,
    ControlIds: ParentControlIds.map((c) => c.value),
    Submitter: data.Submitter.value,
  };
};
